var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ContentRow"},[_c('ce-content-block',{attrs:{"block":_vm.block}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }